'use strict';

import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import * as iiifUtil from '../util/IIIFUtil.js';
import * as domItem from '../viewer/DomItem.js';

const privateMap = util.createPrivateMapper();

class StructureNode {
  constructor(domEl, structureView, nodeData){
    const pv = privateMap(this);
    pv.structureView = structureView;
    this.depth = 0;
    pv.domEl = domEl;
    pv.nodeEl;
    pv.listDomEl = null;
    pv.data = nodeData;
    pv.parent = null;
    pv.folded = false;

  }
  get domEl(){
    return privateMap(this).domEl;
  }
  get listDomEl(){
    return privateMap(this).listDomEl;
  }
  get data(){
    return privateMap(this).data;
  }
  get isFolded(){
    return privateMap(this).folded;
  }

  get content(){
    return privateMap(this).contentEl;
  }
  set content(contentEl) {
    const pv = privateMap(this);
    if (pv.contentEl && pv.contentEl.parentNode == this.domEl) {
      domUtil.detach(pv.contentEl);
    }
    // domUtil.empty(pv.domEl);
    pv.contentEl = contentEl;
    if (pv.contentEl) {
      pv.domEl.insertBefore(contentEl, pv.domEl.firstChild);
    }
  }

  addChild(childNode){
    const pv = privateMap(this);
    childNode.depth = this.depth + 1;
    if (!pv.listDomEl) {
      pv.listDomEl = pv.structureView.createListNode(pv.data);
      pv.domEl.appendChild(pv.listDomEl);
      domUtil.dispatchEvent(pv.domEl, 'ui.childlistcreated');
    }
    pv.listDomEl.appendChild(childNode.domEl);
  }
  fold(){
    const pv = privateMap(this);
    if (!pv.listDomEl) {
      return;
    }
    pv.folded = true;
    domUtil.setStyle(pv.listDomEl, 'display', 'none');
  }
  unfold(){
    const pv = privateMap(this);
    if (!pv.listDomEl) {
      return;
    }
    pv.folded = false;
    domUtil.setStyle(pv.listDomEl, 'display', '');
  }
}

export class StructureView extends UiComponent {
  constructor (domEl, argOptions) {
    super(domEl);
    const pv = privateMap(this);

    const options = argOptions ? argOptions : {};

    pv.refMap = {};
    pv.selectedNodes = [];
    pv.initializeNode = options.initializeNode ? options.initializeNode : function(){};
    pv.createListNode = options.createListNode ? options.createListNode : function(){ return domUtil.createElement('ul'); };
    pv.createNode = options.createNode ? options.createNode : function(){ return domUtil.createElement('li'); };

    pv.rootNodeEl = options.rootNodeEl ? options.rootNodeEl : pv.createListNode();

    if (!options.rootNodeEl) {
      domEl.appendChild(pv.rootNodeEl);
    }
  }

  reset(){
    const pv = privateMap(this);
    pv.refMap = {};
    domUtil.empty(pv.rootNodeEl);
  }

  addNode(parentId, id, nodeData) {
    const pv = privateMap(this);
    const parentNode = pv.refMap[parentId];
    const node = new StructureNode(pv.createNode(parentNode), this, nodeData);
    pv.initializeNode.call(node);

    pv.refMap[id] = node;
    if (!parentNode) {
      if (parentId) {
        console.error(`parent id not found. id:${parentId}`);
      }
      pv.rootNodeEl.appendChild(node.domEl);
      return;
    }
    parentNode.addChild(node);
    domUtil.dispatchEvent(node.domEl, 'ui.changedepth', {
      detail: node
    });
  }

  createListNode(){
    const pv = privateMap(this);
    return pv.createListNode();
  }

  selectIds(ids){
    const pv = privateMap(this);
    const idsMap = {};
    const unchangedIdMap = {};
    if (ids) {
      ids.forEach(id => {
        idsMap[id] = true;
      })
    }
    pv.selectedNodes.forEach(id => {
      if (idsMap[id]) {
        unchangedIdMap[id] = true;
        return;
      }
      const nd = pv.refMap[id];
      if (!nd) {
        return;
      }
      domUtil.dispatchEvent(nd.domEl, 'ui.selectionchanged', {
        detail: false
      });
    });
    pv.selectedNodes.length = 0;
    if (!ids) {
      return;
    }
    ids.forEach(id => {
      pv.selectedNodes.push(id);
      if (unchangedIdMap[id]) {
        return;
      }
      const nd = pv.refMap[id];
      domUtil.dispatchEvent(nd.domEl, 'ui.selectionchanged', {
        detail: true
      });
    });
  };
};
